/**
 * @generated SignedSource<<ecedf72b16f2f82ecb3d7c1b142f392a>>
 * @relayHash 51ffcb6f0382c368dd423834c1103bd9
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID beded1719351cfe921973db7b8019c662a88e65844201784c111e71b1ead9b7e

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type GlobalSideNavigationDataProviderQuery$variables = {
  entityAriUserSideNavSettings: string;
  ownerAri: string;
};
export type GlobalSideNavigationDataProviderQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"GlobalSideNavigation">;
};
export type GlobalSideNavigationDataProviderQuery = {
  response: GlobalSideNavigationDataProviderQuery$data;
  variables: GlobalSideNavigationDataProviderQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "entityAriUserSideNavSettings"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "ownerAri"
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GlobalSideNavigationDataProviderQuery",
    "selections": [
      {
        "kind": "FragmentSpread",
        "name": "GlobalSideNavigation"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GlobalSideNavigationDataProviderQuery",
    "selections": [
      {
        "alias": "userSideNavSettings",
        "args": [
          {
            "kind": "Variable",
            "name": "entityAri",
            "variableName": "entityAriUserSideNavSettings"
          },
          {
            "kind": "Variable",
            "name": "ownerAri",
            "variableName": "ownerAri"
          }
        ],
        "concreteType": "SettingsNavigationCustomisation",
        "kind": "LinkedField",
        "name": "settings_navigationCustomisation",
        "plural": false,
        "selections": [
          {
            "concreteType": "SettingsMenuItemConnection",
            "kind": "LinkedField",
            "name": "sidebar",
            "plural": false,
            "selections": [
              {
                "concreteType": "SettingsMenuItem",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                  {
                    "kind": "ScalarField",
                    "name": "menuId"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "visible"
                  }
                ]
              }
            ]
          },
          {
            "kind": "ScalarField",
            "name": "id"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "beded1719351cfe921973db7b8019c662a88e65844201784c111e71b1ead9b7e",
    "metadata": {},
    "name": "GlobalSideNavigationDataProviderQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "c0fec11dad36206fde7a9f8471f2fbc0";

export default node;
